import { B as l } from "./chunk-BaseElement-GuTcWj1p.js";
import { h as f } from "./chunk-task-4yBfzZiu.js";
import { r as h, x as n } from "./chunk-lit-element-fTUROFeD.js";
import { t as m } from "./chunk-custom-element-BugcqQdL.js";
import { n as v } from "./chunk-property-DOK3RaQn.js";
import { o as d } from "./chunk-unsafe-html-Cdilvd_C.js";
const g = `/*! tailwindcss v4.1.18 | MIT License | https://tailwindcss.com */
svg{width:100%;height:100%}`;
var w = Object.defineProperty, u = Object.getOwnPropertyDescriptor, p = (r, e, o, s) => {
  for (var t = s > 1 ? void 0 : s ? u(e, o) : e, c = r.length - 1, a; c >= 0; c--)
    (a = r[c]) && (t = (s ? a(e, o, t) : a(t)) || t);
  return s && t && w(e, o, t), t;
};
let i = class extends l {
  constructor() {
    super(), this.iconAssetUrl = window.routes.icons, this._svgTask = new f(this, {
      task: async ([r], { signal: e }) => {
        const o = `${this.iconAssetUrl}/${r}.svg`, s = await fetch(o, {
          signal: e
        });
        if (!s.ok)
          throw new Error(s.statusText);
        return await s.text();
      },
      args: () => [this.src]
    });
  }
  connectedCallback() {
    super.connectedCallback();
  }
  render() {
    return this._svgTask.render({
      pending: () => n`<span><!--loading icon--></span>`,
      complete: (r) => n`
          <div class="block h-full w-full">${d(r)}</div>
        `,
      error: () => n`<span><!--Error loading icon--></span>`
    }) || n`<span><!--Error loading icon--></span>`;
  }
};
i.styles = [h(g)];
p([
  v({ type: String })
], i.prototype, "src", 2);
i = p([
  m("svg-icon")
], i);
export {
  i as SvgIcon
};
